import { useMemo } from 'react';

import type { ComponentId } from '@vgtv/api-client/lib/component';

import { useAppSelector } from '../../modules/hooks';
import { selectCategoriesForComponent } from '../../modules/components';
import { useVendor } from '../VendorPovider/VendorPovider';

export const useComponentCategories = (id: ComponentId) => {
  const { vendor } = useVendor();
  const categories = useAppSelector((state) =>
    selectCategoriesForComponent(state, vendor, id)
  );

  if (vendor === 'brandstudio') {
    // "Newest" categories first (by id)
    categories.sort((a, b) => b.id - a.id);
  }

  const foundCategoryIds = categories.map(({ id }) => id).join(',');

  // deliberately skipping categories in dependency list
  // eslint-disable-next-line react-hooks/exhaustive-deps
  return useMemo(() => categories, [foundCategoryIds]);
};
